import React from 'react';

import logo from '../../assets/IG_Logo_Circle.png';

const PageHeader = () => {
    return (
        <div>
        <nav class="navbar navbar-expand-lg bg-body-tertiary container-fluid">
        <div class="container-fluid">
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 justify-content-center">
              <li class="nav-item">
                <button class="nav-link active navbar-brand btn btn-link" aria-current="page">Home</button>
              </li>
              <li class="nav-item">
                <button class="nav-link navbar-brand btn btn-link">Services</button>
              </li>
              {/* <li class="nav-item">
                <button class="nav-link navbar-brand btn btn-link">Map</button>
              </li> */}
              <li class="nav-item">
                <button class="nav-link navbar-brand btn btn-link">About</button>
              </li>
            </ul>
            <ul class="navbar-nav mb-2 mb-lg-0">
              <li class="nav-item">
                <button class="nav-link navbar-brand btn btn-link"><a href="tel:+18155921265" style={{textDecoration: "none", color: "black", userSelect: "text"}}>1-815-592-1265</a></button>
              </li>
              <li class="nav-item">
                <button class="nav-link navbar-brand btn btn-link">
                  {/* <a href="mailto:ogimagegroupphotography@gmail.com">ogimagegroupphotography@gmail.com</a> */}
                  <a href="mailto:thejurevichs@aol.com" style={{textDecoration: "none", color: "black", userSelect: "text"}}>thejurevichs@aol.com</a>
                </button>
              </li>
              <li class="nav-item">
                <button class="nav-link navbar-brand btn btn-link">
                  <a href="https://www.google.com/maps?q=933+North+Convent+St,+Bourbonnais,+IL" target="_blank" rel="noreferrer" style={{textDecoration: "none", color: "black", userSelect: "text"}}>
                    933 N Convent St, Bourbonnais, IL 60914
                  </a>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
        <header className="headerStyle">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div  class="image-container" style={{ flex: '0 0 auto' }}>
                    <img src={logo} className="App-logo" class="background-image" alt="logo" style={{ width: '200px', height: '200px' }} />
                </div>
                <div style={{ flex: '1', textAlign: 'center' }}>
                    <h1 className="headerFontAdjust">The Original Image Group</h1>
                </div>
            </div>
        </header>
      </div>
    );
};

export default PageHeader;